/**
 * String inflection utilities for proper text formatting
 */

/**
 * Convert a string to title case, handling underscores and multiple words properly
 * Examples:
 * - "hello_world" -> "Hello World"
 * - "in_progress" -> "In Progress"
 * - "complete" -> "Complete"
 * - "not_synced" -> "Not Synced"
 */
export function titleize(str: string | null | undefined): string {
  if (!str) return '';

  return str
    .split(/[_\s-]+/) // Split on underscores, spaces, or hyphens
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
